import { render, staticRenderFns } from "./ModalValorDiferenciadoRemover.vue?vue&type=template&id=0be0852a&scoped=true&"
import script from "./ModalValorDiferenciadoRemover.vue?vue&type=script&lang=js&"
export * from "./ModalValorDiferenciadoRemover.vue?vue&type=script&lang=js&"
import style0 from "./ModalValorDiferenciadoRemover.vue?vue&type=style&index=0&id=0be0852a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be0852a",
  null
  
)

export default component.exports